import { apiService } from './apiService'

export const marketChatService = {
  async send(messages, debug = false) {
    const response = await apiService.request('/api/market-chat', {
      method: 'POST',
      body: JSON.stringify({ messages, debug }),
    })
    const data = await response.json().catch(() => ({}))
    if (!response.ok) throw new Error(data.message || `Market AI request failed (${response.status})`)
    return data
  },
}
